import { DEFAULT_PROJETO } from "../constants"
import { Projeto } from "../types"

export const resetarProjeto = (projeto: Projeto): Projeto => {
  return {
    ...DEFAULT_PROJETO,
    id: projeto.id,
    distribuidor: projeto.distribuidor,
    distribuidor_id: projeto.distribuidor_id,
    cliente_proposta: projeto.cliente_proposta,
    regioes: projeto.regioes,
    revenda: projeto.revenda,
    revenda_id: projeto.revenda_id,
    titulo: projeto.titulo,
    email_proposta: projeto.email_proposta,
    cpf_cnpj_proposta: projeto.cpf_cnpj_proposta,
    cep: projeto.cep,
    estado: projeto.estado,
    cidade: projeto.cidade,
    endereco_proposta: projeto.endereco_proposta,
    numero: projeto.numero,
    bairro: projeto.bairro,
    telefone_proposta: projeto.telefone_proposta,
  }
}